import styled from "styled-components";

const FAQStyleWrapper = styled.section`
  position: relative;
  padding-bottom: 130px;
  padding-top: 100px;
  height: 900px;

  .bithu_title_text {
    font-family: "Bakbak One";
    color: #fff;
    margin-top: 50px;
    span {
      display: block;
      a {
        text-decoration: none;
        color: #B27F4B;
        padding-left: 10px;
        font-family: 'Bakbak One';
      }
    }
  }

  .bithu_faq_content {
    width: 100%;
    margin: auto;
    position: relative;
  }

  .bithu_faq_questions {
    position: relative;

    .faq_questions {
      position: relative;
      z-index: 1;

      .accordion__item + .accordion__item {
        margin-top: 10px;
      }
    }
  }
  .accordion__item {
    background: rgba(255, 255, 255, 0.05);
    backdrop-filter: blur(10px);
  }
  .accordion__header {
    h5 {
      display: flex;
      align-items: center;
      height: 76px;
      margin-bottom: 0px;
      padding: 0 29px;
      color: rgba(255, 255, 255, 0.8);
      font-size: 24px;
      line-height: 34px;
      text-transform: none;
    }
  }

  .accordion__body {
    p {
      padding: 0px 48px 24px 29px;
      font-family: Inter;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 28px;
      color: rgba(255, 255, 255, 0.7);
      margin-bottom: 0px;
      max-width: 100%;
    }
  }

  .faq_bg_wattermark {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 0;
  }

  .skeleton-pointing-up {
    position: absolute;
    top: 40%;
    left: 10%;
  }

  @media only screen and (max-width: 1330px) {
    .skeleton-pointing-up {
      top: 40%;
      left: 5%;
      height: 450px;
      width: 450px;
    }
  }

  @media (max-width: 1199px) {
    height: 950px;
  }

  @media only screen and (max-width: 991px) {
    margin-top: -100px;

    height: 1000px;

    .section_title {
      margin-bottom: 57px;
      text-align: center;
    }

    .accordion__header {
      h5 {
        font-size: 18px;
        line-height: 28px;
      }
    }

    .skeleton-pointing-up {
      display: none;
    }
  }

  @media only screen and (max-width: 767px) {
    height: auto;

    margin-top: -100px;
  }

  @media only screen and (max-width: 667px) {
    .bithu_title_text {
      margin: 30px 0 57px 0;
    }
  }

  @media only screen and (max-width: 500px) {
    .accordion__header {
      h5 {
        font-size: 20px;
        line-height: 25px;
      }
    }

    .accordion__body {
      p {
        font-size: 14px;
        line-height: 25px;
      }
    }
  }

  @media only screen and (max-width: 480px) {
    .accordion__header {
      h5 {
        font-size: 18px;
      }
    }
  }

  @media (max-width: 380px) {
    .accordion__header {
      h5 {
        font-size: 18px;
        line-height: 20px;
        margin-right: 0px;
        padding-right: 5px;
      }
    }
  }

  @media (max-width: 320px) {
    .section_title h2{
      font-size: 12px;
    }
  }

  
  @media (max-width: 352px) {
    .accordion__header {
      h5 {
        font-size: 16px;
        line-height: 18px;
      }
    }
  }

  
  @media (max-width: 326px) {
    .accordion__header {
      h5 {
        font-size: 16px;
        line-height: 18px;
      }
    }
  }

  
  @media (max-width: 297px) {
    .accordion__header {
      h5 {
        padding-right: 10px;
      }
    }
  }
`;

export default FAQStyleWrapper;
